/**
 * TokenNotFound — Error state when token is not found or API fails.
 *
 * Story 4.2 — Task 6
 */

import { Link } from "@tanstack/react-router";

import { EmptyState } from "../ui/EmptyState";

export function TokenNotFound() {
	return (
		<div className="mx-auto max-w-7xl px-4 py-16">
			<EmptyState
				title="Token not found"
				description="The token you're looking for doesn't exist or has been removed."
				icon={
					<svg
						className="h-12 w-12"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="1.5"
						aria-hidden="true"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
						/>
					</svg>
				}
				action={
					<Link
						to="/discover"
						className="inline-flex items-center gap-2 rounded-lg bg-pastel-vibrant-blue px-4 py-2.5 text-sm font-medium text-white hover:opacity-90 transition-opacity"
					>
						Back to Discover
					</Link>
				}
			/>
		</div>
	);
}
